// TypeScript shape mirrors of the FastAPI Pydantic schemas.
// Hand-maintained for now; could be auto-generated from /openapi.json later.
import { t } from '@/lib/i18n';
/** ITIL-aligned human labels for the priority codes (ServiceNow / Jira SM
 *  pattern). Surfaced on the ticket create/edit forms so requesters see what
 *  each level means; config screens (SLA, templates) keep the bare code. */
export const PRIORITY_LABELS = {
    P1: 'Critical',
    P2: 'High',
    P3: 'Medium',
    P4: 'Low',
};
/** Display label for a ticket status (owner decision 2026-07-31): the
 *  underlying `open` state is SHOWN as "Pending – Engineer Assignment" —
 *  dispatch parks the ticket there until the engineer is confirmed. Pure
 *  display mapping; the stored status value is untouched, so filters and
 *  saved views keep working. */
export function statusDisplay(s) {
    if (s === 'open')
        return t('Pending – Engineer Assignment');
    return t(s.replace(/_/g, ' '));
}
/** "P1 — Critical" for dropdown options (severity word translated). */
export function priorityLabel(p) {
    return `${p} — ${t(PRIORITY_LABELS[p])}`;
}
/** Industry-standard ITSM/FSM resolution (closure) codes — mirrors the
 *  backend `ResolutionCode` enum. Used by the resolve form on ticket detail.
 *  Added 2026-06-24 (owner-requested): cancelled / re_scheduled /
 *  parts_ordered / customer_unavailable / out_of_scope / escalated_to_vendor
 *  — matches Salesforce Field Service + MS Dynamics 365 FS closure outcomes
 *  for field-service heavy tenants. */
export const RESOLUTION_CODES = [
    'fixed',
    'workaround_provided',
    'not_reproducible',
    'duplicate',
    'no_action_required',
    'replaced_hardware',
    'configuration_change',
    'user_education',
    'vendor_resolved',
    'cancelled',
    're_scheduled',
    'parts_ordered',
    'customer_unavailable',
    'out_of_scope',
    'escalated_to_vendor',
];
